import React from 'react';
import { useTheme } from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SaveInstallationPlanForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';



export type SaveInstallationPlanModalProps = {
  id: string; // installationId
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveInstallationPlanModalProps) => {
  const theme = useTheme();
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      title={`${props.id === '' ? 'Save' : 'Edit'} Plan`}
      subTitle='Select a plan for this finish'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={(
        <CustomIcon.large.FC
          icon='PLUS'
          stroke={theme.palette.primary.main}
        />
      )}
      id={props.id}
    >
      <SaveInstallationPlanForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={() => props.handleClose()}
      />
    </BasicFormModalLayout.FC>
  );
};
